module.exports = __webpack_public_path__ + "static/media/pin-correios.29b2e901.svg";